import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import signature from "../../../../assets/img/cachet.png";
import "./styles/toPrint.css";
import {
  frenchDateOnly,
  transformImmatriculation,
} from "../../../../variables/functions";
import axiosInstance from "../../../../variables/api/axiosInstance";
import { displayNumbers } from "../../../../variables/numbersFunctions";
import AntidateBadge from "./AntidateBadge";
import DuplicataStamp from "./DuplicataStamp";

const DTRFWPPFormatToPrint = React.forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const [primeRC, setPrimeRC] = useState(0);
  const [primeIndC, setPrimeIndC] = useState(0);
  const [primeNette, setPrimeNette] = useState(0);
  const [taxes, setTaxes] = useState(0);
  const [primeTotale, setPrimeTotale] = useState(0);

  useEffect(() => {
    var dts = [];
    var puissance = 0;
    props.contrat?.engins &&
      (puissance = props?.contrat?.engins[0].puissance
        ? parseInt(props?.contrat?.engins[0].puissance)
        : props?.contrat?.engins[0].volume
          ? props?.contrat?.engins[0].volume
          : 0);

    var categorieId = 0;
    props.contrat?.engins &&
      (categorieId = props?.contrat?.engins[0]?.categorie?.categorieId);
    axiosInstance.get(`/api/sous-garantie/compulsory-guaranties/${puissance}/${categorieId}`)
      .then((res) => {
        // console.log("Dataaaaa: ", res.data);
        res.data.forEach((cg, cgi) => {
          dts.push({
            key: `${cgi + dts.length}`,
            garantie: `${cg?.nom}`,
            capital: cg?.capital
              ? cg?.nom !== "RC"
                ? `${displayNumbers(cg?.capital)}`
                : "-"
              : "-",
            franchise: 0,
            bns: 0,
            reduc_comm: 0,
            reduc_flotte: 0,
            prime_nette: `${displayNumbers(
              cg?.primeNette,
            )}`,
          });
        });

        props?.contrat?.engins?.forEach((eng) => {
          eng.sousGaranties.forEach((sousGarantie, idx) => {
            if (
              sousGarantie?.garantie?.nom === "Incendie" ||
              sousGarantie?.garantie?.nom === "Vol"
            ) {
              var pNette = sousGarantie?.primeNette
                ? sousGarantie?.primeNette
                : sousGarantie?.tauxPCent
                  ? (sousGarantie?.tauxPCent * eng.valeurDeclaree) / 100
                  : eng.tauxPMille
                    ? (sousGarantie?.tauxPMille * eng.valeurDeclaree) / 1000
                    : 0.0;

              dts.push({
                key: `${idx + dts.length}`,
                garantie: `${sousGarantie?.garantie?.nom === "Individuel Conducteur"
                  ? sousGarantie?.nom
                  : sousGarantie?.garantie?.nom
                  }`,
                capital: sousGarantie.tauxPCent
                  ? `${displayNumbers(
                    (sousGarantie.primeNette * 100) / sousGarantie.tauxPCent,
                  )}`
                  : sousGarantie.tauxPMille
                    ? `${displayNumbers(
                      (sousGarantie.primeNette * 1000) /
                      sousGarantie.tauxPMille,
                    )}`
                    : "-",
                franchise: 0,
                bns: 0,
                reduc_comm: 0,
                reduc_flotte: 0,
                prime_nette: `${displayNumbers(pNette)}`,
              });
            } else {
              dts.push({
                key: `${idx + dts.length}`,
                garantie: `${sousGarantie?.garantie?.nom === "Individuel Conducteur"
                  ? sousGarantie?.nom
                  : sousGarantie?.garantie?.nom
                  }`,
                capital: sousGarantie.tauxPCent
                  ? `${displayNumbers(
                    (sousGarantie.primeNette * 100) / sousGarantie.tauxPCent,
                  )}`
                  : sousGarantie.tauxPMille
                    ? `${displayNumbers(
                      (sousGarantie.primeNette * 1000) /
                      sousGarantie.tauxPMille,
                    )}`
                    : "-",
                franchise: 0,
                bns: 0,
                reduc_comm: 0,
                reduc_flotte: 0,
                prime_nette: `${displayNumbers(
                  sousGarantie.primeNette,
                )}`,
              });
            }
          });
        });
        setData(dts);
        // console.log("DTS: ", dts);
        setPrimeIndC(dts?.find((el) => el.garantie !== "RC")?.prime_nette);
        setPrimeRC(dts?.find((el) => el.garantie === "RC")?.prime_nette);
        const primeN =
          parseFloat(dts?.find((el) => el.garantie !== "RC")?.prime_nette) +
          parseFloat(dts?.find((el) => el.garantie === "RC")?.prime_nette);
        console.log("Prime nettte: ", primeN * 1000 + 2000);
        setPrimeNette(primeN * 1000);
        setTaxes(Math.trunc((primeN * 1000 + 2000) * 0.06));
        setPrimeTotale(Math.trunc((primeN * 1000 + 2000) * 1.06));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [props?.contrat]);

  return (
    <div
      ref={ref}
      style={{
        width: "210mm",
        height: "297mm",
        backgroundImage: `none`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: "absolute",
      }}
    >
      <AntidateBadge contrat={props.contrat} />
      <DuplicataStamp contrat={props.contrat} />
      <div className="row">
        {(props?.contrat?.producteur?.agence?.ville === "LOME" || props?.contrat?.producteur?.agence === null) && (<div
          className="col"
          style={{ position: "relative", left: "10px", top: "-10px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "68px",
              marginTop: "131px",
            }}
          >
            <b>
              {`${props?.contrat?.producteur?.agence?.nom ? props?.contrat?.producteur?.agence?.nom : "DTRF Lomé"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "500px",
              marginTop: "15px",
            }}
          >
            <b>
              {/* {`Imprimée le ${frenchDateOnly(new Date().toISOString())}`} */}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "350px",
              marginTop: "122px",
            }}
          >
            <b>
              {`${props.contrat?.numeroPoliceM ? props.contrat?.numeroPoliceM : props.contrat?.numeroPoliceP}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "650px",
              marginTop: "119px",
            }}
          >
            <b>{`${frenchDateOnly(props.contrat?.dateEffet)}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "650px",
              marginTop: "137px",
            }}
          >
            <b>{`${frenchDateOnly(props.contrat?.dateEcheance)}`}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "340px",
              marginTop: "142px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.concessionnaire?.raisonSociale ? props.contrat?.engins[0]?.concessionnaire?.raisonSociale : "-"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "82px",
              marginTop: "301px",
            }}
          >
            <b>
              {`${props.contrat?.souscripteur?.nom} ${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.prenom : ""}`}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "592px",
              marginTop: "298px",
            }}
          >
            <b>
              {`${props.contrat?.producteur ? props.contrat?.producteur?.personne?.nom : ""}`}{" "}
              {`${props.contrat?.producteur ? (props.contrat?.producteur?.personne?.prenom ? props.contrat?.producteur?.personne?.prenom : "") : ""}`}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "100px",
              marginTop: "329px",
            }}
          >
            <b>
              {props?.contrat?.souscripteur?.profession
                ? props?.contrat?.souscripteur?.profession
                : "-"}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "355px",
              marginTop: "325px",
            }}
          >
            <b>
              {`${props.contrat?.souscripteur?.adresse ? props.contrat?.souscripteur?.adresse : "-"}`}
              {` ${props.contrat?.souscripteur?.contact && props.contrat?.souscripteur?.contact?.[0] !== undefined ? props.contrat?.souscripteur?.contact[0] : "-"}`}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "270px",
              marginTop: "377px",
            }}
          >
            <b>
              {`${transformImmatriculation(props.contrat?.engins[0]?.immatriculation).toUpperCase()}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "93px",
              marginTop: "406px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.marque?.toUpperCase()}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "385px",
              marginTop: "403px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.carosserie ? props.contrat?.engins[0]?.carosserie : "CADRE"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "648px",
              marginTop: "401px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.dateMiseEnCirculation ? props.contrat?.engins[0]?.dateMiseEnCirculation?.split("-")[0] : "2024"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "95px",
              marginTop: "427px",
            }}
          >
            <b>
              {props.contrat?.engins[0]?.volume
                ? `${props.contrat?.engins[0]?.volume}cm3`
                : props.contrat?.engins[0]?.puissance}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "190px",
              marginTop: "427px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.energie}`}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "385px",
              marginTop: "422px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.numeroChassis?.toUpperCase()}`}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "90px",
              marginTop: "444px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.nombrePlace ? props.contrat?.engins[0]?.nombrePlace : "2"}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "190px",
              marginTop: "445px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.genre ? props.contrat?.engins[0]?.genre : "-"}`}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "388px",
              marginTop: "441px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.moteur?.toUpperCase()}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "93px",
              marginTop: "464px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.categorie?.codeCategorie?.startsWith("M") ? "5. MOTOS" : props.contrat?.engins[0]?.categorie?.codeCategorie}`}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "386px",
              marginTop: "460px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.usage}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "542px",
            }}
          >
            <b>{data?.find((el) => el.garantie === "RC")?.prime_nette}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "562px",
            }}
          >
            <b>Gratuit</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "715px",
              marginTop: "733px",
            }}
          >
            <b>{data?.find((el) => el.garantie !== "RC")?.prime_nette}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "787px",
            }}
          >
            <b>{displayNumbers(props.contrat?.primeNette)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "718px",
              marginTop: "807px",
            }}
          >
            <b>2.000</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "718px",
              marginTop: "824px",
            }}
          >
            <b>{displayNumbers(taxes)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "841px",
            }}
          >
            <b>{displayNumbers(props.contrat?.primeTotale)}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "385px",
              marginTop: "890px",
            }}
          >
            <b>
              {`${props.contrat?.producteur ? (props.contrat?.producteur?.agence ? props.contrat?.producteur?.agence?.ville : "Lomé") : "Lomé"}
                      , le ${frenchDateOnly(new Date().toISOString())}`}
            </b>
          </h6>
          {/*<div style={{ position: "absolute" }}>*/}
          <img
            src={signature}
            alt="Signature"
            style={{
              position: "absolute",
              marginLeft: "505px",
              marginTop: "990px",
              width: "20%"
            }}
          />
          {/*</div>*/}
        </div>)}
        {/* Kpalimé */}
        {props?.contrat?.producteur?.agence?.ville?.trim() === "KPALIME" && (<div
          className="col"
          style={{ position: "relative", left: "10px", top: "0px" }}
        >
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "68px",
              marginTop: "131px",
            }}
          >
            <b>
              {`${props?.contrat?.producteur?.agence?.nom ? props?.contrat?.producteur?.agence?.nom : "DTRF Lomé"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "500px",
              marginTop: "15px",
            }}
          >
            <b>
              {/* {`Imprimée le ${frenchDateOnly(new Date().toISOString())}`} */}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "350px",
              marginTop: "122px",
            }}
          >
            <b>
              {`${props.contrat?.numeroPoliceM ? props.contrat?.numeroPoliceM : props.contrat?.numeroPoliceP}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "650px",
              marginTop: "119px",
            }}
          >
            <b>{`${frenchDateOnly(props.contrat?.dateEffet)}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "650px",
              marginTop: "137px",
            }}
          >
            <b>{`${frenchDateOnly(props.contrat?.dateEcheance)}`}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "340px",
              marginTop: "142px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.concessionnaire?.raisonSociale ? props.contrat?.engins[0]?.concessionnaire?.raisonSociale : "-"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "82px",
              marginTop: "301px",
            }}
          >
            <b>
              {`${props.contrat?.souscripteur?.nom} ${props.contrat?.souscripteur?.prenom ? props.contrat?.souscripteur?.prenom : ""}`}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "592px",
              marginTop: "298px",
            }}
          >
            <b>
              {`${props.contrat?.producteur ? props.contrat?.producteur?.personne?.nom : ""}`}{" "}
              {`${props.contrat?.producteur ? (props.contrat?.producteur?.personne?.prenom ? props.contrat?.producteur?.personne?.prenom : "") : ""}`}{" "}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "100px",
              marginTop: "329px",
            }}
          >
            <b>
              {props?.contrat?.souscripteur?.profession
                ? props?.contrat?.souscripteur?.profession
                : "-"}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "355px",
              marginTop: "325px",
            }}
          >
            <b>
              {`${props.contrat?.souscripteur?.adresse ? props.contrat?.souscripteur?.adresse : "-"}`}
              {` ${props.contrat?.souscripteur?.contact && props.contrat?.souscripteur?.contact?.[0] !== undefined ? props.contrat?.souscripteur?.contact[0] : "-"}`}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "270px",
              marginTop: "377px",
            }}
          >
            <b>
              {`${transformImmatriculation(props.contrat?.engins[0]?.immatriculation).toUpperCase()}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "93px",
              marginTop: "406px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.marque?.toUpperCase()}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "385px",
              marginTop: "403px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.carosserie ? props.contrat?.engins[0]?.carosserie : "CADRE"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "648px",
              marginTop: "401px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.dateMiseEnCirculation ? props.contrat?.engins[0]?.dateMiseEnCirculation?.split("-")[0] : "2024"}`}
            </b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "95px",
              marginTop: "427px",
            }}
          >
            <b>
              {props.contrat?.engins[0]?.volume
                ? `${props.contrat?.engins[0]?.volume}cm3`
                : props.contrat?.engins[0]?.puissance}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "190px",
              marginTop: "427px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.energie}`}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "385px",
              marginTop: "422px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.numeroChassis?.toUpperCase()}`}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "90px",
              marginTop: "444px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.nombrePlace ? props.contrat?.engins[0]?.nombrePlace : "2"}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "190px",
              marginTop: "445px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.genre ? props.contrat?.engins[0]?.genre : "-"}`}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "388px",
              marginTop: "441px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.moteur?.toUpperCase()}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "93px",
              marginTop: "464px",
            }}
          >
            <b>
              {`${props.contrat?.engins[0]?.categorie?.codeCategorie?.startsWith("M") ? "5. MOTOS" : props.contrat?.engins[0]?.categorie?.codeCategorie}`}
            </b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "386px",
              marginTop: "460px",
            }}
          >
            <b>{`${props.contrat?.engins[0]?.usage}`}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "542px",
            }}
          >
            <b>{data?.find((el) => el.garantie === "RC")?.prime_nette}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "562px",
            }}
          >
            <b>Gratuit</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "715px",
              marginTop: "733px",
            }}
          >
            <b>{data?.find((el) => el.garantie !== "RC")?.prime_nette}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "787px",
            }}
          >
            <b>{displayNumbers(props.contrat?.primeNette)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "718px",
              marginTop: "807px",
            }}
          >
            <b>2.000</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "718px",
              marginTop: "824px",
            }}
          >
            <b>{displayNumbers(taxes)}</b>
          </h6>
          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "710px",
              marginTop: "841px",
            }}
          >
            <b>{displayNumbers(props.contrat?.primeTotale)}</b>
          </h6>

          <h6
            className="text-left"
            style={{
              position: "absolute",
              marginLeft: "385px",
              marginTop: "890px",
            }}
          >
            <b>
              {`${props.contrat?.producteur ? (props.contrat?.producteur?.agence ? props.contrat?.producteur?.agence?.ville : "Lomé") : "Lomé"}
                      , le ${frenchDateOnly(new Date().toISOString())}`}
            </b>
          </h6>
          {/*<div style={{ position: "absolute" }}>*/}
          <img
            src={signature}
            alt="Signature"
            style={{
              position: "absolute",
              marginLeft: "505px",
              marginTop: "990px",
              width: "20%"
            }}
          />
          {/*</div>*/}
        </div>)}
      </div>
    </div>
  );
});
DTRFWPPFormatToPrint.propTypes = {
  contrat: PropTypes.object,
  engin: PropTypes.object,
  printing: PropTypes.bool,
};
DTRFWPPFormatToPrint.displayName = "CP VT";

export default DTRFWPPFormatToPrint;